/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CountryCode,
  CountryCodeOptional,
  CountryCodeMetaI,
  CountryCodeTrackedI,
} from "./country-code";
import { CountryCodeTracked, CountryCodeMeta } from "./country-code";
// May contain unused imports in some cases
// @ts-ignore
import type {
  USStateCode,
  USStateCodeOptional,
  USStateCodeMetaI,
  USStateCodeTrackedI,
} from "./usstate-code";
import { USStateCodeTracked, USStateCodeMeta } from "./usstate-code";

/**
 *
 * @export
 * @interface AddressNoStatus
 */
export interface AddressNoStatusOptional {
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line1?: string;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line2?: string;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line3?: string;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressNoStatus
   */
  state?: USStateCode;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  city?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressNoStatus
   */
  country?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  zip?: string;
}

export interface AddressNoStatus extends AddressNoStatusOptional {
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line1: string;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line2?: string;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line3?: string;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressNoStatus
   */
  state?: USStateCode;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  city?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressNoStatus
   */
  country: CountryCode;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  zip?: string;
}

export interface AddressNoStatusTrackedI {
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line1?: string;
  line1IsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line2?: string;
  line2IsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  line3?: string;
  line3IsSet: boolean;
  /**
   *
   * @type {USStateCode}
   * @memberof AddressNoStatus
   */
  state?: USStateCode;
  stateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  city?: string;
  cityIsSet: boolean;
  /**
   *
   * @type {CountryCode}
   * @memberof AddressNoStatus
   */
  country?: CountryCode;
  countryIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof AddressNoStatus
   */
  zip?: string;
  zipIsSet: boolean;
}

transformDatesMap.set("AddressNoStatus", function (model: AddressNoStatus) {});

export type AddressNoStatusMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  line1: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  line2: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  line3: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  state: PropertyMeta<USStateCodeMetaI>;
  //isDate: false
  //isDatetime: false
  city: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  country: PropertyMeta<CountryCodeMetaI>;
  //isDate: false
  //isDatetime: false
  zip: PropertyMeta<MetaTypeBase<string>>;
}>;

export var AddressNoStatusMeta: AddressNoStatusMetaI =
  {} as AddressNoStatusMetaI;
AddressNoStatusMeta = typeMeta("AddressNoStatus", {
  line1: propertyMeta("line1", false, true, false, MetaTypesBase.string),
  line2: propertyMeta("line2", false, false, false, MetaTypesBase.string),
  line3: propertyMeta("line3", false, false, false, MetaTypesBase.string),
  state: propertyMeta("state", false, false, false, USStateCodeMeta),
  city: propertyMeta("city", false, false, false, MetaTypesBase.string),
  country: propertyMeta("country", false, true, false, CountryCodeMeta),
  zip: propertyMeta("zip", false, false, false, MetaTypesBase.string),
});

const metaI = AddressNoStatusMeta;

registerMeta(() => {});

export class AddressNoStatusTracked implements AddressNoStatusTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  line1__I?: string = undefined;
  line1IsSet: boolean = false;
  set line1(v: undefined | string) {
    if (v !== undefined) {
      this.line1__I = v;
      this.line1IsSet = true;
    } else {
      this.line1__I = v || undefined;
      this.line1IsSet = true;
    }
    this.changeTracker = true;
  }
  get line1() {
    return this.line1__I;
  }
  line2__I?: string = undefined;
  line2IsSet: boolean = false;
  set line2(v: undefined | string) {
    if (v !== undefined) {
      this.line2__I = v;
      this.line2IsSet = true;
    } else {
      this.line2__I = v || undefined;
      this.line2IsSet = false;
    }
    this.changeTracker = true;
  }
  get line2() {
    return this.line2__I;
  }
  line3__I?: string = undefined;
  line3IsSet: boolean = false;
  set line3(v: undefined | string) {
    if (v !== undefined) {
      this.line3__I = v;
      this.line3IsSet = true;
    } else {
      this.line3__I = v || undefined;
      this.line3IsSet = false;
    }
    this.changeTracker = true;
  }
  get line3() {
    return this.line3__I;
  }
  state__I?: USStateCode = undefined;
  stateIsSet: boolean = false;
  set state(v: undefined | USStateCode) {
    if (v !== undefined) {
      this.state__I = v;
      this.stateIsSet = true;
    } else {
      this.state__I = v || undefined;
      this.stateIsSet = false;
    }
    this.changeTracker = true;
  }
  get state() {
    return this.state__I;
  }
  city__I?: string = undefined;
  cityIsSet: boolean = false;
  set city(v: undefined | string) {
    if (v !== undefined) {
      this.city__I = v;
      this.cityIsSet = true;
    } else {
      this.city__I = v || undefined;
      this.cityIsSet = false;
    }
    this.changeTracker = true;
  }
  get city() {
    return this.city__I;
  }
  country__I?: CountryCode = undefined;
  countryIsSet: boolean = false;
  set country(v: undefined | CountryCode) {
    if (v !== undefined) {
      this.country__I = v;
      this.countryIsSet = true;
    } else {
      this.country__I = v || undefined;
      this.countryIsSet = true;
    }
    this.changeTracker = true;
  }
  get country() {
    return this.country__I;
  }
  zip__I?: string = undefined;
  zipIsSet: boolean = false;
  set zip(v: undefined | string) {
    if (v !== undefined) {
      this.zip__I = v;
      this.zipIsSet = true;
    } else {
      this.zip__I = v || undefined;
      this.zipIsSet = false;
    }
    this.changeTracker = true;
  }
  get zip() {
    return this.zip__I;
  }
  constructor(config?: AddressNoStatusOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: AddressNoStatusOptional,
    options?: AssignOptions,
  ): AddressNoStatusTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.line1 && this.line1ApplyFilter(optionsRequired.filter)) {
      this.line1 = config.line1;
      if (optionsRequired.unassign) this.line1IsSet = false;
      else this.line1IsSet = true;
    }
    if (config.line2 && this.line2ApplyFilter(optionsRequired.filter)) {
      this.line2 = config.line2;
      if (optionsRequired.unassign) this.line2IsSet = false;
      else this.line2IsSet = true;
    }
    if (config.line3 && this.line3ApplyFilter(optionsRequired.filter)) {
      this.line3 = config.line3;
      if (optionsRequired.unassign) this.line3IsSet = false;
      else this.line3IsSet = true;
    }
    if (config.state && this.stateApplyFilter(optionsRequired.filter)) {
      this.state = config.state;
      if (optionsRequired.unassign) this.stateIsSet = false;
      else this.stateIsSet = true;
    }
    if (config.city && this.cityApplyFilter(optionsRequired.filter)) {
      this.city = config.city;
      if (optionsRequired.unassign) this.cityIsSet = false;
      else this.cityIsSet = true;
    }
    if (config.country && this.countryApplyFilter(optionsRequired.filter)) {
      this.country = config.country;
      if (optionsRequired.unassign) this.countryIsSet = false;
      else this.countryIsSet = true;
    }
    if (config.zip && this.zipApplyFilter(optionsRequired.filter)) {
      this.zip = config.zip;
      if (optionsRequired.unassign) this.zipIsSet = false;
      else this.zipIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AddressNoStatusTrackedI {
    const cloned = {} as AddressNoStatusTrackedI;
    if (
      this.line1IsSetDeep() &&
      this.line1ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line1IsSet = true;
      cloned.line1 = this.line1;
    } else {
      //cloned.line1IsSet = false
    }
    if (
      this.line2IsSetDeep() &&
      this.line2ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line2IsSet = true;
      cloned.line2 = this.line2;
    } else {
      //cloned.line2IsSet = false
    }
    if (
      this.line3IsSetDeep() &&
      this.line3ApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.line3IsSet = true;
      cloned.line3 = this.line3;
    } else {
      //cloned.line3IsSet = false
    }
    if (
      this.stateIsSetDeep() &&
      this.stateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stateIsSet = true;
      cloned.state = this.state;
    } else {
      //cloned.stateIsSet = false
    }
    if (
      this.cityIsSetDeep() &&
      this.cityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cityIsSet = true;
      cloned.city = this.city;
    } else {
      //cloned.cityIsSet = false
    }
    if (
      this.countryIsSetDeep() &&
      this.countryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.countryIsSet = true;
      cloned.country = this.country;
    } else {
      //cloned.countryIsSet = false
    }
    if (
      this.zipIsSetDeep() &&
      this.zipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.zipIsSet = true;
      cloned.zip = this.zip;
    } else {
      //cloned.zipIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AddressNoStatusTrackedI {
    if (!this.line1ApplyFilter(filter)) this.line1IsSet = false;

    if (!this.line2ApplyFilter(filter)) this.line2IsSet = false;

    if (!this.line3ApplyFilter(filter)) this.line3IsSet = false;

    if (!this.stateApplyFilter(filter)) this.stateIsSet = false;

    if (!this.cityApplyFilter(filter)) this.cityIsSet = false;

    if (!this.countryApplyFilter(filter)) this.countryIsSet = false;

    if (!this.zipApplyFilter(filter)) this.zipIsSet = false;

    return this;
  }
  line1ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.line1,
      AddressNoStatusMeta,
      this.line1,
      this,
    );
  }
  line1IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line1IsSet && this.line1ApplyFilter(filter)) return true;

    return false;
  }
  line2ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.line2,
      AddressNoStatusMeta,
      this.line2,
      this,
    );
  }
  line2IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line2IsSet && this.line2ApplyFilter(filter)) return true;

    return false;
  }
  line3ApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.line3,
      AddressNoStatusMeta,
      this.line3,
      this,
    );
  }
  line3IsSetDeep(filter?: FilterVarsType): boolean {
    if (this.line3IsSet && this.line3ApplyFilter(filter)) return true;

    return false;
  }
  stateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.state,
      AddressNoStatusMeta,
      this.state,
      this,
    );
  }
  stateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stateIsSet && this.stateApplyFilter(filter)) return true;

    return false;
  }
  cityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.city,
      AddressNoStatusMeta,
      this.city,
      this,
    );
  }
  cityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cityIsSet && this.cityApplyFilter(filter)) return true;

    return false;
  }
  countryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AddressNoStatusMeta.country,
      AddressNoStatusMeta,
      this.country,
      this,
    );
  }
  countryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.countryIsSet && this.countryApplyFilter(filter)) return true;

    return false;
  }
  zipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(AddressNoStatusMeta.zip, AddressNoStatusMeta, this.zip, this);
  }
  zipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.zipIsSet && this.zipApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.line1IsSetDeep(filter)) return true;
    if (this.line2IsSetDeep(filter)) return true;
    if (this.line3IsSetDeep(filter)) return true;
    if (this.stateIsSetDeep(filter)) return true;
    if (this.cityIsSetDeep(filter)) return true;
    if (this.countryIsSetDeep(filter)) return true;
    if (this.zipIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
